import * as React from 'react';
import { Panel, PanelType } from '@fluentui/react';
import { TaskDetailContent } from '../details/TaskDetailContent';
import type {
    AgentTaskProposalVoteUpdateResult,
    AgentTaskTaskDetailResult,
} from '../types';

export function TaskDetailPanel(props: {
    isOpen: boolean;
    serviceName: string;
    taskListId: number;
    taskListDisplayName?: string;
    taskId?: number;
    snapshotId?: number;
    onDismiss: () => void;
    onProposalCountsChanged?: (
        taskId: number,
        counts: Pick<
            AgentTaskProposalVoteUpdateResult,
            'activeProposalCount' | 'votedProposalCount' | 'okProposalCount'
        >,
    ) => void;
    hasPreviousTask?: boolean;
    hasNextTask?: boolean;
    onNavigatePreviousTask?: () => void;
    onNavigateNextTask?: () => void;
    prefetchedTask?: AgentTaskTaskDetailResult;
}) {
    const {
        isOpen,
        serviceName,
        taskListId,
        taskListDisplayName,
        taskId,
        snapshotId,
        onDismiss,
        onProposalCountsChanged,
        hasPreviousTask,
        hasNextTask,
        onNavigatePreviousTask,
        onNavigateNextTask,
        prefetchedTask,
    } = props;

    return (
        <Panel
            isLightDismiss
            isOpen={isOpen && taskId !== undefined}
            onDismiss={onDismiss}
            type={PanelType.extraLarge}
            allowTouchBodyScroll
            styles={{
                commands: {
                    height: 0,
                    minHeight: 0,
                    overflow: 'visible',
                    paddingTop: 0,
                },
                navigation: { height: 0, minHeight: 0 },
                closeButton: {
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    zIndex: 2,
                    width: 32,
                    height: 32,
                },
            }}
        >
            {taskId !== undefined && (
                <TaskDetailContent
                    serviceName={serviceName}
                    taskListId={taskListId}
                    taskListDisplayName={taskListDisplayName}
                    taskId={taskId}
                    snapshotId={snapshotId}
                    onProposalCountsChanged={onProposalCountsChanged}
                    hasPreviousTask={hasPreviousTask}
                    hasNextTask={hasNextTask}
                    onNavigatePreviousTask={onNavigatePreviousTask}
                    onNavigateNextTask={onNavigateNextTask}
                    prefetchedTask={prefetchedTask}
                />
            )}
        </Panel>
    );
}
